import { RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material"
import { GRID_FORM_CONFIG_T } from "../../../../common/FormGenerator"
import { RadioGroupStyle } from "./style"
import { AutocompleteInput } from "../../../../components/ui-kit/AutocompleteInput"
import { PROJECT_TYPE_OPTIONS, ProjectStageEnum } from "../../../../consts/projectTypeOptions"
import { russiaRegionsOptions } from "../../../../consts/russiaRegions"

export type FiltrationBlockName =
    | "name"
    | "stage"
    | "region"
    | "description"
    | "full_description"
    | "env_factor"
    | "expected_result"
    | "necessary_actions"
    | "initial_state"
    | "implementation"
    | "type"

export const nameConfig = [
    [
        {
            id: 1,
            controllerName: "name",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Название — до 240 символов",
                fullWidth: true,
                size: "small",
                inputProps: { maxLength: 240 },
            }),
        },
    ],
]

export const stageConfig = [
    [
        {
            id: 2,
            controllerName: "stage",
            RenderElement: RadioGroup,
            renderProps: () => ({
                row: true,
                sx: RadioGroupStyle,
                children: [
                    <FormControlLabel key={1} value={ProjectStageEnum.IDEA} control={<Radio />} label="1. Идея" />,
                    <FormControlLabel key={2} value={ProjectStageEnum.PLANNING} control={<Radio />} label="2. Планирование" />,
                    <FormControlLabel key={3} value={ProjectStageEnum.IMPLEMENTATION} control={<Radio />} label="3. Реализация" />,
                    <FormControlLabel key={4} value={ProjectStageEnum.TESTING} control={<Radio />} label="4. Тестирование" />,
                    <FormControlLabel key={5} value={ProjectStageEnum.COMPLETED} control={<Radio />} label="5. Работает" />,
                    <FormControlLabel key={6} value={ProjectStageEnum.PHASE_SIX} control={<Radio />} label="6. Завершён" />,
                ],
            })
        }
    ]
]

export const regionConfig = [
    [
        {
            id: 3,
            controllerName: "region",
            RenderElement: AutocompleteInput,
            renderProps: (formProps: any) => ({
                options: russiaRegionsOptions,
                freeSolo: false,
                fullWidth: true,
                size: "small",
                placeholder: "Выберите регион",
                error: formProps.error,
            }),
        }
    ]
]

export const descriptionConfig = [
    [
        {
            id: 4,
            controllerName: "description",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Краткое описание проекта...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const fullDescriptionConfig = [
    [
        {
            id: 11,
            controllerName: "full_description",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Полное описание проекта...",
                fullWidth: true,
                multiline: true,
                minRows: 4,
                size: "small",
            }),
        },
    ],
]

export const envFactorConfig = [
    [
        {
            id: 5,
            controllerName: "env_factor",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Укажите, что для вас является проблемой с целью которой запускается проект...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const expectedResultConfig = [
    [
        {
            id: 6,
            controllerName: "expected_result",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какова должна быть конечная цель проекта...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const initialStateConfig = [
    [
        {
            id: 7,
            controllerName: "initial_state",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Конкретные шаги и запросы, необходимые для реализации...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const necessaryActionsConfig = [
    [
        {
            id: 8,
            controllerName: "necessary_actions",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какого положение дел на текущий момент...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const implementationConfig = [
    [
        {
            id: 9,
            controllerName: "implementation",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какие инструменты будут задействованы...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const typeConfig = [
    [
        {
            id: 10,
            controllerName: "type",
            RenderElement: AutocompleteInput,
            renderProps: (formProps: any) => ({
                options: PROJECT_TYPE_OPTIONS,
                freeSolo: false,
                disableClearable: true,
                fullWidth: true,
                size: "small",
                placeholder: "Выберите тип проекта",
                error: formProps.error,
            }),
        }
    ]
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
    name: nameConfig,
    stage: stageConfig,
    region: regionConfig,
    description: descriptionConfig,
    full_description: fullDescriptionConfig,
    env_factor: envFactorConfig,
    expected_result: expectedResultConfig,
    necessary_actions: necessaryActionsConfig,
    initial_state: initialStateConfig,
    implementation: implementationConfig,
    type: typeConfig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]
